import { isVNode } from 'vue';
/** Convert string / VNode / TooltipProps into TooltipProps (antd ≥ 5.25). */
function convertToTooltipProps(tooltip) {
    if (tooltip === undefined || tooltip === null) {
        return null;
    }
    if (typeof tooltip === 'object' && !isVNode(tooltip) && !Array.isArray(tooltip)) {
        return tooltip;
    }
    return {
        title: tooltip,
    };
}
export default convertToTooltipProps;
